import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import P from '@deliveroo/consumer-component-library/components/P';

import styles from './styles.scss';

export default function Bubble({ time, label, reverseLabel, isPlaceholder }) {
  const bubbleClasses = classnames(styles.bubble, {
    [styles['bubble-reverse']]: reverseLabel,
  });

  return (
    !isPlaceholder && (
      <span className={bubbleClasses}>
        <span className={classnames(styles.homeTime)}>
          <P size="small" isBold>
            {time}
          </P>
        </span>
        <span className={styles.label}>
          <P size="x-small" color="grey">
            {label}
          </P>
        </span>
      </span>
    )
  );
}

Bubble.propTypes = {
  time: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  reverseLabel: PropTypes.bool.isRequired,
  isPlaceholder: PropTypes.bool,
};

Bubble.defaultProps = {
  isPlaceholder: false,
};
